import axios from "axios";
import { appConfig } from "../enviroments/enviroment";
import { catch_error } from "../firebase/functions";

var start_on = 0;
var initial_button_text = "تحميل المزيد";
var loading_button_text = "تحميل...";

let cookbooks_response;
let cookbooks = new Array();

jQuery(document).ready(function ($) {
  $(document).on("click", "#cookbooks_loadmore", function (e) {
    e.preventDefault();
    append_cookbooks();
  });
  if (
    window.location.pathname == "/cookbooks" ||
    window.location.pathname == "/cookbooks/" ||
    window.location.pathname == "/atyabtabkha/cookbooks"
  ) {
    get_public_cookbooks(false);
  }
});

function get_public_cookbooks(is_after) {
  let url = `${appConfig.API.URL}/getCookbooks`;
  if (is_after) {
    url += `?startAfter=${cookbooks_response.timestamp}`;
  }

  let access_token = JSON.parse(
    localStorage.getItem("login_result")
  )?.access_token;

  axios
    .get(url, {
      headers: {
        "x-api-key": appConfig.API.KEY,
        Authorization: ` Bearer ${access_token}`,
      },
    })
    .then((res) => {
      cookbooks_response = res.data;
      cookbooks = cookbooks.concat(res.data.usersCookbooks);
    })
    .then(() => {
      append_cookbooks();
    })

    .catch((err) => {
      catch_error(err);
    });
}

function append_cookbooks() {
  $("#cookbooks_loadmore").text(loading_button_text);
  $("#cookbooks_loadmore").attr("disabled", true);
  $("#cookbooks_loadmore").prop("disabled", true);

  let new_cookbooks = cookbooks.slice(start_on, start_on + 24);

  if (new_cookbooks.length < 24) {
    get_public_cookbooks(true);
  } else {
    let data = `&action=load_cookbooks&public_cookbooks=true&public_cookbooks=${JSON.stringify(
      new_cookbooks
    )}`;
    $.ajax({
      type: "POST",
      dataType: "html",

      url: load_cookbooks.ajaxurl,
      data: data,
      success: function (res) {
        $("#cookbooks_loadmore").text(initial_button_text);
        $("#cookbooks_loadmore").attr("disabled", false);
        $("#cookbooks_loadmore").prop("disabled", false);
        $("#cookbooks_loadmore").css("display", "block");

        $("#public_cookbooks_container").append(res);
        start_on += 24;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $("#cookbooks_loadmore").text(initial_button_text);
        $("#cookbooks_loadmore").attr("disabled", false);
        $("#cookbooks_loadmore").prop("disabled", false);

        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
      },
    });
  }
}

$(document).on("click", "#cookbooks_loadmore", function (e) {
  e.preventDefault();
  append_cookbooks();
});
